export default {
  data() {
    return {
      referral: [
        {
          id: 1,
          name: "BROKERS",
          alias: "brokers"
        }
      ]
    };
  },

  created() {
    if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 12]))
      this.referral = [
        ...this.referral,
        {
          id: 2,
          name: "USERS",
          alias: "users"
        }
      ];
  }
};
